var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.items && _vm.items.length) ? _c('div', [(!_vm.nohead) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "margin-bottom": "10px"
    }
  }, [_vm._v("操作日志")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scroll-none",
    staticStyle: {
      "overflow": "scroll",
      "overflow-y": "hidden",
      "display": "grid",
      "width": "100%",
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "border-radius": "4px",
        "border": "1px solid #eee",
        "width": "200px",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "background-color": "#f8f8f8",
        "padding": "10px",
        "font-weight": "bold",
        "border-bottom": "1px solid #eee"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', [_vm._v("操作者：" + _vm._s(item.zhanghao.name))]), _vm._v(" "), _c('div', [_vm._v("时间：" + _vm._s(item.createTimeStr))]), _vm._v(" "), (item.beizhu) ? _c('div', [_vm._v("备注：" + _vm._s(item.beizhu))]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  })]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19d8ca14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d8ca14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Caozuojilu.vue
// module id = 7F6j
// module chunks = 142